export const CREATE_SUPPORT_REQUEST = "CREATE_SUPPORT_REQUEST";
export const CREATE_SUPPORT_SUCCESS = "CREATE_SUPPORT_SUCCESS";
export const CREATE_SUPPORT_FAILURE = "CREATE_SUPPORT_FAILURE";
